<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Lista zgłoszeń</h4>
              <Link :href="route('service.create')" class="btn btn-outline-primary"
                    v-if="hasPermission('canAddService')">
                <i class="bi bi-plus-circle"></i>&nbsp;Dodaj zgłoszenie
              </Link>
            </div>
          </div>
        </div>
        <div class="text-end mb-3">
          <div class="d-inline-block me-3 text-start" style="vertical-align: top">
            <div class="form-check form-switch form-switch-success">
              <input class="form-check-input" type="checkbox" role="switch" id="showArchivedServices"
                     style="height:1.5em; width:3em;" v-model="archivedServicesShown" @change="showArchivedServices()">
              <label class="form-check-label" for="showArchivedServices" style="margin: 3px 0 0 10px;">Pokaż
                zarchiwizowane</label>
            </div>
            <div class="form-check form-switch form-switch-success">
              <input class="form-check-input" type="checkbox" role="switch" id="showHiddenServices"
                     style="height:1.5em; width:3em;" v-model="hiddenServicesShown" @change="showHiddenServices()">
              <label class="form-check-label" for="showHiddenServices" style="margin: 3px 0 0 10px;">Pokaż
                ukryte</label>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table table-responsive">
            <table id="mojaTabela" ref="dataTables" class="table table-hover"/>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePage} from "@inertiajs/vue3";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import Swal from 'sweetalert2';
import axios from 'axios';

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, hasPermission},
  name: 'DataTable',
  data() {
    return {
      archivedServicesShown: false,
      hiddenServicesShown: false,
      table: null,
      hasPermission,
      selectedYear: new Date().getFullYear(),
    }
  },
  watch: {
    selectedYear: {
      handler() {
        this.fetchData();
      },
      immediate: true
    }
  },

  mounted() {
    const {data} = usePage().props;
    this.user = usePage().props.user;
    this.initDataTable(data);
    this.initFilters();
    $(document).on('click', '.delete-service-btn', (event) => {
      const serviceId = $(event.currentTarget).data('id');
      this.deleteService(serviceId);
    });
    $(document).on('change', '.update-status', (event) => {
      const serviceId = $(event.currentTarget).data('id');
      const newStatus = $(event.currentTarget).val();
      this.updateServiceStatus(serviceId, newStatus);
    });

    $(document).on('click', '.edit-invoice-btn', function (event) {
      const serviceId = $(this).data('id');
      $(`.invoice-display[data-id="${serviceId}"]`).addClass('d-none');
      $(`.invoice-edit[data-id="${serviceId}"]`).removeClass('d-none');
    });

    $(document).on('click', '.save-invoice-btn', function (event) {
      const serviceId = $(this).data('id');
      const invoiceInput = $(this).closest('.input-group').find('.invoice-input-field');
      const newInvoice = invoiceInput.val();

      if (!newInvoice) return;

      axios.post(`/service/update-invoice/${serviceId}`, {invoice_number: newInvoice})
          .then(() => {
            invoiceInput.val(newInvoice).prop('readonly', true);
            Swal.fire({
              icon: 'success',
              title: 'Sukces',
              text: 'Numer faktury został zapisany!',
              timer: 1500,
              showConfirmButton: false
            });

            $('#mojaTabela').DataTable().ajax.reload(null, false);
          })
          .catch(() => {
            Swal.fire({
              icon: 'error',
              title: 'Błąd',
              text: 'Nie udało się zapisać numeru faktury!'
            });
          });
    });
    $(document).on('click', '.set-invoice-btn', function (event) {
      const serviceId = $(this).data('id');
      const newInvoice = $(`.invoice-edit[data-id="${serviceId}"] .invoice-input-field`).val();
      axios.post(`/service/update-invoice/${serviceId}`, {invoice_number: newInvoice})
          .then(() => {
            const displayDiv = $(`.invoice-display[data-id="${serviceId}"]`);
            displayDiv.find('.invoice-input-field').val(newInvoice).prop('readonly', true);
            displayDiv.removeClass('d-none');
            $(`.invoice-edit[data-id="${serviceId}"]`).addClass('d-none');

            Swal.fire({
              icon: 'success',
              title: 'Sukces',
              text: 'Numer faktury został zaktualizowany!',
              timer: 1500,
              showConfirmButton: false
            });
            $('#mojaTabela').DataTable().ajax.reload(null, false);
          })
          .catch(() => {
            Swal.fire({icon: 'error', title: 'Błąd', text: 'Nie udało się zaktualizować numeru faktury!'});
          });
    });

  },

  methods: {

    route,
    updateServiceStatus(serviceId, newStatus) {
      axios.post(`/service/update-status/${serviceId}`, {status: newStatus})
          .then(response => {
            Swal.fire({
              icon: 'success',
              title: 'Sukces',
              text: 'Status został zaktualizowany!',
              timer: 2000,
              showConfirmButton: false
            });
          })
          .catch(error => {
            Swal.fire({
              icon: 'error',
              title: 'Błąd',
              text: 'Nie udało się zapisać statusu!',
            });
          });
    },
 
    showArchivedServices() {
      this.table.draw();
    },

    showHiddenServices() {
      this.table.draw();
    },

    initDataTable() {
      const self = this;
      const csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
      this.table = $(this.$refs.dataTables).DataTable({
        colReorder: true,
        stateSave: true,
        serverSide: true,
        processing: true,
        order: [[0, 'desc']],
        ajax: {
          url: '/get-services-datatables',
          type: 'GET',
          data: function (params) {
            params.showArchived = self.archivedServicesShown;
            params.showHidden = self.hiddenServicesShown;
            params.withoutHidden = true;
            return params;
          },
          dataSrc: function (json) {
            return json.data;
          }
        },


        stateSaveCallback: function (settings, data) {
          $.ajax({
            url: '/save-column-data?table=services',
            data: data,
            type: 'POST',
            dataType: 'json',
            headers: {'X-CSRF-TOKEN': csrfToken},
          });
        },
        stateLoadCallback: function (settings) {
          var o;
          $.ajax({
            url: '/get-services-datatables',
            async: false,
            dataType: 'json',
            success: function (json) {
              o = json;
            }
          });
          let elem = this;
          self.initColumnSearch(elem, o);
          return o;
        },
        columns: [
          {
            data: 'id',
            title: '#',
            name: 'id',
            width: "5%",
            isUnique: true
          },
          {
            data: 'service_number',
            title: 'Numer',
            name: 'service_number',
            width: "10%",
            render: function (data, idx, row) {
              let goEdit = hasPermission('canEditService')
                  ? `<a href="${route('service.show', row.id)}" class="text-primary">${data}</a>`
                  : `${data}`;

              return goEdit;
            },
          },

          {
            data: 'customer_name', title: 'Klient', name: 'customer_name', width: "25%",
            render: function (data, idx, row) {
              let goUser = hasPermission('canViewClients')
                  ? `<a class="text-primary" href="/customers/${row.customer_id}">${data}</a>`
                  : `${data}`;

              return goUser;

            },
          },
          {
            data: 'project_name', title: 'Project', name: 'project_name', width: "25%",
            render: function (data, idx, row) {

              let goProject = (hasPermission('canEditBasicProject') || hasPermission('canEditAdvancedProject'))
                  ? `<a href="${route('projects.show', row.project_id)}" class="text-primary">${data}</a>`
                  : `${data}`;

              return goProject;
            },

          },
          {
            name: 'status',
            title: 'Status',
            class: 'status options',
            data: function (d) {
              let optionObject = ['NOWE', 'ZREALIZOWANE', 'ROZLICZONE'];
              let options = optionObject.map(option =>
                  `<option value="${option}" ${option === d.status ? "selected" : ""}>${option}</option>`
              ).join('');

              let disabled = hasPermission('canChangeServiceStatus') ? '' : 'disabled';

              return `
      <select 
        style="width: 180px; font-size: 10px" 
        name="status" 
        ${disabled}
        class="form-select form-select-sm update-status"
        data-id="${d.id}">
        ${options}
      </select>
      <div class="statusMessage text-danger d-none small"></div>
    `;
            },
          },
          {
            name: 'invoice_number',
            title: 'Faktura',
            class: 'invoice-number-input',
            data: function (d) {
              const hasPermissionToEdit = hasPermission('canChangeServiceStatus');
              const invoice = d.invoice_number || '';
              const serviceId = d.id;

              return `
      <div class="invoice-display" data-id="${serviceId}">
        <div class="input-group input-group-sm" style="width: 180px;">
          <input 
            type="text" 
            class="form-control invoice-input-field" 
            value="${invoice}" 
            ${invoice ? 'readonly' : ''} 
            style="font-size: 12px;color:black;"
          />
          <button 
            class="btn btn-outline-secondary ${invoice ? 'edit-invoice-btn' : 'save-invoice-btn'}" 
            data-id="${serviceId}">
            ${invoice ? 'Zmień' : 'Zapisz'}
          </button>
        </div>
      </div>
      <div class="invoice-edit d-none" data-id="${serviceId}">
        <div class="input-group input-group-sm" style="width: 180px;">
          <input 
            type="text" 
            class="form-control invoice-input-field" 
            value="${invoice}" 
            style="font-size: 12px;"
          />
          <button 
            class="btn btn-outline-secondary set-invoice-btn" 
            data-id="${serviceId}">
            Zapisz
          </button>
        </div>
      </div>
    `;
            },
          },
          {
            data: 'created_at',
            title: 'Data utworzenia',
            name: 'created_at',
            width: "15%",
            render: function (data) {
              if (!data) return '';
              return new Date(data).toLocaleDateString('pl-PL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              });
            }
          },
          {
            data: 'ended_at',
            title: 'Data zakończenia',
            name: 'ended_at',
            width: "15%",
            render: function (data) {
              if (!data) return '';
              return new Date(data).toLocaleDateString('pl-PL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              });
            }
          },
          {
            data: 'total_cost',
            title: 'Koszt (klienta)',
            name: 'total_cost',
            width: "25%",

            render: function (data, idx, row) {
              let result = '';

              if (hasPermission('canEditService')) {
                result = `<center><a href="${route('service.costs', row.id)}" class="text-primary">${data}</a></center>`;
              } else if (hasPermission('canViewClientPrice')) {
                result = `<center>${data}</center><br>`;
              }

              if (hasPermission('canServicePDF')) {
                let buttons = `
    <div class="mx-auto d-flex flex-column align-items-center gap-1" style="width: 180px;">
  `;

                if (row.has_costs) {
                  buttons += `
      <a class="btn btn-info btn-sm" style="width: 140px;" rel="noopener noreferrer" target="_blank" href="${route('service.generatePdf', row.id)}">
        <i class="bi bi-file-earmark-pdf"></i> Koszta
      </a>
    `;
                }

                if (row.has_protocol) {
                  buttons += `
      <a class="btn btn-info btn-sm" style="width: 140px;" rel="noopener noreferrer" target="_blank" href="${route('service.generatePdfprotocol', row.id)}">
        <i class="bi bi-file-earmark-pdf"></i> Protokół
      </a>
    `;
                }

                if (row.has_filesprotocol) {
                  buttons += `
      <a class="btn btn-info btn-sm" style="width: 140px;" rel="noopener noreferrer" target="_blank" href="${route('service.showprotocolattch', row.id)}">
        <i class="bi bi-file-earmark-text"></i> Pliki protokołu
      </a>
    `;
                }

                buttons += `</div>`;
                result += buttons;
              }

              return result;
            },
          },
          {
            data: 'description',
            name: 'description',
            visible: false,
            searchable: true
          },
          {
            data: 'service_protocol_description',
            name: 'service_protocol.description',
            visible: false,
            searchable: true
          },
        ],
        createdRow: function (row, data, dataIndex) {
          const link = $(row).find('a[data-edit]');
          link.on('click', function (event) {
            event.preventDefault();
            const id = $(this).data('edit');
            self.generateEditServiceLink(id);
          });

          if (data.archived === 1) {
            $(row).addClass('strikeout');
          }
        },
      });
    },
    initColumnSearch(elem, o) {
      setTimeout(() => {
        var api = elem.api();
        api.columns().eq(0).each(function (colIdx) {
          var cell = $('.filters td').eq($(api.column(colIdx).header()).index());
          var title_cell = $('th').eq($(api.column(colIdx).header()).index());

          let searchText = o?.columns?.[colIdx]?.search?.search || "";

          if (searchText) {
            $(cell).html('<input type="text" value="' + searchText + '" />');
          } else {
            let title = $(title_cell).text();
            $(cell).html('<input type="text" placeholder="' + title + '" />');
          }

          $('input', $('.filters td').eq($(api.column(colIdx).header()).index()))
              .off('keyup change')
              .on('change keyup', function (e) {
                $(this).attr('title', $(this).val());
                api.column($(this).parent().index()).search(this.value).draw();
              });
        });
      }, 50);
    },
    generateEditServiceLink(id) {
      this.$inertia.visit(route('services.show', {project: id}));
    },

    initFilters() {
      const headerRow = $(this.$refs.dataTables).find('thead tr');
      const inputRow = document.createElement('tr');

      headerRow.find('th').each(function (index) {
        const inputCell = document.createElement('td');
        const input = document.createElement('input');
        input.type = 'text';
        input.placeholder = 'Filter...';

        $(inputCell).addClass('filters').css('max-width', '30px');
        $(inputCell).addClass('filters').append(input);
        $(inputRow).addClass('filters').append(inputCell);
      });

      headerRow.after(inputRow);
    },
  },
}
</script>
